"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const StoryDescription_module_css_1 = __importDefault(require("./StoryDescription.module.css"));
const topics = (description) => {
    // This logic will find all of the topics in a description, and
    // reformat them to make them bold, leaving the rest of the
    // description as normal.
    const topicsRE = new RegExp(/[#][^\s]+/, "g");
    const split = description.split(topicsRE);
    const topicMatches = description.matchAll(topicsRE);
    const topics = Array.from(topicMatches).flatMap((topic) => topic[0]);
    return split.map((splitDescription, index) => ((0, jsx_runtime_1.jsxs)("span", { className: StoryDescription_module_css_1.default.description, children: [splitDescription, topics[index] && ((0, jsx_runtime_1.jsx)("a", { target: "_blank", href: `https://www.snapchat.com/explore/${topics[index].substring(1)}`, className: StoryDescription_module_css_1.default.topic, children: topics[index] }))] }, topics[index])));
};
/**
 *
 */
function StoryDescription({ description }) {
    return (0, jsx_runtime_1.jsx)("div", { className: StoryDescription_module_css_1.default.descriptionContainer, children: topics(description) });
}
exports.StoryDescription = StoryDescription;
//# sourceMappingURL=StoryDescription.js.map